import {
  WireChannel,
  WireNameValue,
  WireProduct,
  WireQuoteRequestBase,
  WireStatus,
  WireTransactionType,
} from '../types';

export enum WirePaymentFrequency {
  Annual = 'Annual',
  Monthly = 'Monthly',
  Unspecified = '',
}

export enum WirePaymentMethod {
  CreditCard = 'CreditCard',
  BPAY = 'BPAY',
  DebitCard = 'DebitCard',
}

export type WirePayment = {
  frequency: WirePaymentFrequency;
  method: WirePaymentMethod;
  date: string;
  bsbDetails?: {
    number: string;
    accountNumber: string;
    accountName: string;
    bankName: string;
    branchPostcode: string;
    branchAddress: string;
  };
  ccDetails?: {
    singleUseToken: string;
  };
};

export type WireBindRequest = WireQuoteRequestBase & {
  version: string;
  product: WireProduct;
  transactionType: WireTransactionType;
  targetStatus: WireStatus;
  channel: WireChannel;
  policyNumber: string;
  policyReference: string;
  payment: WirePayment;
  metaData: WireNameValue[];
};
